import { useContext } from 'react';
import { viewTypeContext } from './viewTypeContext';

export function useViewTypeContext() {
  return useContext(viewTypeContext);
}
